import React from "react"
import { withStyles } from '@material-ui/core';
import { styles } from "./style";
import UserContext from 'context/UserContext';
import Loader from "storybookComponents/Loader"
import Report from "./components/Report"
import { getSavedReports } from "relay/campaigns"
import EmptyViewCampaign from "images/EmptyViewCampaign.svg"




const MyAnalytics = ({ classes, allCampaigns, propertiesOfOrg, handlePreviewClick, showNotification }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [loading, setLoading] = React.useState(true);
  const [reports, setReports] = React.useState([])

  React.useEffect(() => {
    init();
  }, [1]);


  const init = async () => {
    setLoading(true)
    try {
      let response = await getSavedReports(subOrgDetails.id)
      if (response.savedReports) {
        setReports(response.savedReports)
      }
    } catch (err) {
      console.log("err", err)
    }
    setLoading(false)
  }


  if (loading) {
    return <Loader />
  }

  const renderCards = (report, index) => {
    return <Report report={report} key={index} allCampaigns={allCampaigns} propertiesOfOrg={propertiesOfOrg} handlePreviewClick={handlePreviewClick} subOrgDetails={subOrgDetails} showNotification={showNotification} />
  }
  return (
    <div className={classes.super}>
      <div className={classes.header}>My Analytics</div>
      {reports.length == 0 ?
        <div className={classes.emptyContainer}>
          <div className={classes.emptyText}>
            <img src={EmptyViewCampaign} alt="No Reports" />
            <div>{"It seems there is not Report yet."}</div>

          </div>
        </div> :
        <div className={classes.flexBox}>
          {reports.map(renderCards)}
        </div>
      }

    </div>
  )
}

export default withStyles(styles)(MyAnalytics)